module.exports = __webpack_public_path__ + "img/polygon-logo.62fe2c1a.svg";